/**
 * @file modules/analytics_loader.js
 * @description Picks which analytics system initializes on reskin pages, gated by the
 *              fragno_analytics Flipper flag (window.settings is set server-side in
 *              shared/_scripts.haml, before packs/reskin.js runs). Dynamic import so only
 *              one system's code actually loads and initializes.
 */

export function loadAnalytics(settings) {
  if (settings?.fragno_analytics) {
    return import("../analytics-fragno").catch(console.error);
  }
  return import("../analytics").catch(console.error);
}
